import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://prestijcrm.duckdns.org';

export default function Portfoyler() {
  const [portfoyler, setPortfoyler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [sablonlar, setSablonlar] = useState([]);
  const [acikId, setAcikId] = useState(null);
  const [eslesenMusteriler, setEslesenMusteriler] = useState([]);
  const [secilenSablon, setSecilenSablon] = useState('tanitim');
  const [sablonModal, setSablonModal] = useState(false);
  const [yeniSablon, setYeniSablon] = useState({ ad: '', tip: 'bayram', icerik: '' });
  const token = localStorage.getItem('token');
  const headers = { Authorization: 'Bearer ' + token };

  const listele = async () => {
    setYukleniyor(true);
    try {
      const r = await axios.get(API + '/api/ilanlar?kaynak=ocr-taslak', { headers });
      setPortfoyler(r.data.ilanlar);
    } catch (e) { console.error(e); } finally { setYukleniyor(false); }
  };
  const sablonlariGetir = async () => {
    try { const r = await axios.get(API + '/api/sablonlar', { headers }); setSablonlar(r.data); } catch (e) { console.error(e); }
  };

  useEffect(() => { listele(); sablonlariGetir(); }, []);

  const onayla = async (id) => {
    try {
      await axios.put(API + '/api/ilanlar/' + id, { kaynak: 'manuel' }, { headers });
      listele();
    } catch (e) { alert('Onaylama hatasi'); }
  };
  const sil = async (id) => {
    if (!window.confirm('Bu taslak portfoyu silmek istediginize emin misiniz?')) return;
    try { await axios.delete(API + '/api/ilanlar/' + id, { headers }); listele(); } catch (e) { alert('Silme hatasi'); }
  };

  const musterileriAc = async (id) => {
    if (acikId === id) { setAcikId(null); return; }
    setAcikId(id);
    setSecilenSablon('tanitim');
    try {
      const r = await axios.get(API + '/api/ilanlar/' + id + '/eslesen-musteriler', { headers });
      setEslesenMusteriler(r.data.musteriler || []);
    } catch (e) { setEslesenMusteriler([]); }
  };

  const waNumaraNormallestir = (raw) => {
    let d = String(raw || '').replace(/\D/g, '');
    if (!d) return '';
    if (d.startsWith('0')) d = '90' + d.slice(1);
    else if (!d.startsWith('90')) d = '90' + d;
    return d;
  };

  const mesajGonder = (portfoy, musteri) => {
    const num = waNumaraNormallestir(musteri.whatsapp_number || musteri.phone);
    if (!num || num.length < 11) { alert('Bu musterinin gecerli bir WhatsApp/telefon numarasi yok.'); return; }
    let mesaj;
    if (secilenSablon === 'tanitim') {
      const satirlar = [
        `Merhaba ${musteri.name}, size uygun bir portfoyumuz var:`,
        portfoy.baslik,
        `${portfoy.tip === 'satilik' ? 'Satilik' : 'Kiralik'}${portfoy.oda_sayisi ? ' | ' + portfoy.oda_sayisi : ''}${portfoy.fiyat ? ' | ' + Number(portfoy.fiyat).toLocaleString('tr-TR') + ' TL' : ''}${(portfoy.sehir || portfoy.ilce) ? ' | ' + [portfoy.sehir, portfoy.ilce].filter(Boolean).join('/') : ''}`,
      ];
      mesaj = satirlar.join('\n');
    } else {
      const sablon = sablonlar.find(s => String(s.id) === secilenSablon);
      mesaj = (sablon ? sablon.icerik : '').replace(/\{ad\}/g, musteri.name || '');
    }
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(mesaj)}`, '_blank');
  };

  const sablonKaydet = async () => {
    if (!yeniSablon.ad || !yeniSablon.icerik) { alert('Sablon adi ve icerik zorunlu'); return; }
    try {
      await axios.post(API + '/api/sablonlar', yeniSablon, { headers });
      setYeniSablon({ ad: '', tip: 'bayram', icerik: '' });
      sablonlariGetir();
    } catch (e) { alert('Sablon kaydetme hatasi'); }
  };
  const sablonSil = async (id) => {
    if (!window.confirm('Bu sablonu silmek istediginize emin misiniz?')) return;
    try { await axios.delete(API + '/api/sablonlar/' + id, { headers }); sablonlariGetir(); } catch (e) { alert('Silme hatasi'); }
  };

  const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' };
  const lbl = { display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 };

  return (
    <div style={{ padding: 24, fontFamily: 'Inter,sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#1e293b' }}>Portföyler (Taslak)</h1>
          <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: 14 }}>Fotoğraf/OCR ile çıkarılan, onay bekleyen portföyler — {portfoyler.length} kayıt</p>
        </div>
        <button onClick={() => setSablonModal(true)} style={{ background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>Mesaj Şablonları</button>
      </div>

      {yukleniyor ? <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Yükleniyor...</div>
      : portfoyler.length === 0 ? <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Onay bekleyen taslak portföy yok.</div>
      : portfoyler.map(p => (
        <div key={p.id} style={{ background: '#fff', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: 20, marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
            <div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: p.tip === 'satilik' ? '#dbeafe' : '#dcfce7', color: p.tip === 'satilik' ? '#1d4ed8' : '#16a34a' }}>
                  {p.tip === 'satilik' ? 'Satılık' : 'Kiralık'}
                </span>
                <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, background: '#fef3c7', color: '#b45309' }}>Taslak — Kontrol Et</span>
              </div>
              <div style={{ fontWeight: 700, fontSize: 15, color: '#1e293b' }}>{p.baslik}</div>
              <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>
                {p.oda_sayisi && <>{p.oda_sayisi} · </>}
                {p.alan_m2 && <>{p.alan_m2} m² · </>}
                {p.fiyat && <>{Number(p.fiyat).toLocaleString('tr-TR')} TL · </>}
                {p.sehir}{p.ilce ? '/' + p.ilce : ''}
              </div>
              {p.mulk_sahibi_tel && <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>📞 {p.mulk_sahibi_tel}</div>}
              {p.aciklama && <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 6, maxWidth: 560 }}>{p.aciklama}</div>}
            </div>
            <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
              <button onClick={() => musterileriAc(p.id)} style={{ background: '#eff6ff', color: '#2563eb', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                {acikId === p.id ? 'Kapat' : 'WhatsApp Gönder'}
              </button>
              <button onClick={() => onayla(p.id)} style={{ background: '#dcfce7', color: '#16a34a', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Onayla</button>
              <button onClick={() => sil(p.id)} style={{ background: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Sil</button>
            </div>
          </div>

          {acikId === p.id && (
            <div style={{ marginTop: 16, borderTop: '1px solid #e2e8f0', paddingTop: 16 }}>
              <div style={{ marginBottom: 10 }}>
                <label style={lbl}>Gönderilecek Mesaj</label>
                <select value={secilenSablon} onChange={e => setSecilenSablon(e.target.value)} style={{ ...inp, maxWidth: 320 }}>
                  <option value="tanitim">Tanıtım (portföy bilgisi otomatik)</option>
                  {sablonlar.filter(s => s.aktif).map(s => <option key={s.id} value={String(s.id)}>{s.ad} ({s.tip})</option>)}
                </select>
              </div>
              {eslesenMusteriler.length === 0 ? (
                <p style={{ color: '#64748b', fontSize: 13 }}>Bu portföye uygun müşteri bulunamadı.</p>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {eslesenMusteriler.map(m => (
                    <div key={m.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, background: '#f8fafc', borderRadius: 8, padding: '8px 12px' }}>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 13, color: '#1e293b' }}>{m.name}</div>
                        <div style={{ fontSize: 12, color: '#64748b' }}>{m.budget_min ? Number(m.budget_min).toLocaleString('tr-TR') : '-'} - {m.budget_max ? Number(m.budget_max).toLocaleString('tr-TR') : '-'} TL{m.district ? ' | ' + m.district : ''}</div>
                      </div>
                      <button onClick={() => mesajGonder(p, m)} style={{ background: '#25D366', border: 'none', borderRadius: 6, padding: '6px 12px', color: '#052e16', cursor: 'pointer', fontWeight: 700, fontSize: 12, whiteSpace: 'nowrap' }}>WhatsApp</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      ))}

      {sablonModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 560, maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>Mesaj Şablonları</h2>
              <button onClick={() => setSablonModal(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#64748b' }}>✕</button>
            </div>

            <div style={{ marginBottom: 20 }}>
              {sablonlar.length === 0 ? <p style={{ color: '#64748b', fontSize: 13 }}>Henüz şablon eklenmedi.</p> : sablonlar.map(s => (
                <div key={s.id} style={{ background: '#f8fafc', borderRadius: 8, padding: '10px 14px', marginBottom: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: 13 }}>{s.ad}</span>
                      <span style={{ marginLeft: 8, fontSize: 11, background: '#e0e7ff', color: '#4338ca', padding: '2px 8px', borderRadius: 20 }}>{s.tip}</span>
                    </div>
                    <button onClick={() => sablonSil(s.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 12 }}>Sil</button>
                  </div>
                  <div style={{ fontSize: 12, color: '#64748b', marginTop: 4, whiteSpace: 'pre-wrap' }}>{s.icerik}</div>
                </div>
              ))}
            </div>

            <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 16 }}>
              <label style={lbl}>Yeni Şablon Adı</label>
              <input value={yeniSablon.ad} onChange={e => setYeniSablon(p => ({ ...p, ad: e.target.value }))} style={{ ...inp, marginBottom: 10 }} placeholder="Örn: Ramazan Bayramı" />
              <label style={lbl}>Tip</label>
              <select value={yeniSablon.tip} onChange={e => setYeniSablon(p => ({ ...p, tip: e.target.value }))} style={{ ...inp, marginBottom: 10 }}>
                <option value="bayram">Bayram / Özel Gün</option>
                <option value="tanitim">Tanıtım</option>
                <option value="genel">Genel</option>
              </select>
              <label style={lbl}>Mesaj İçeriği (müşteri adı için {'{ad}'} kullanabilirsiniz)</label>
              <textarea value={yeniSablon.icerik} onChange={e => setYeniSablon(p => ({ ...p, icerik: e.target.value }))} style={{ ...inp, height: 90, resize: 'vertical', marginBottom: 12 }} placeholder="Sayın {ad}, bayramınızı kutlarız..." />
              <button onClick={sablonKaydet} style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>Şablon Ekle</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
